module.exports = __webpack_public_path__ + "img/35.9cfc5140.png";